import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import MarketingShell from "@/components/MarketingShell";

const EASE = [0.4, 0, 0.2, 1];

const LINKS = [
  { to: "/", label: "Home", testid: "notfound-link-home" },
  { to: "/music", label: "Listen now", testid: "notfound-link-music" },
  { to: "/performances", label: "Upcoming performances", testid: "notfound-link-performances" },
  { to: "/podcast", label: "The podcast", testid: "notfound-link-podcast" },
  { to: "/contact", label: "Book Dan", testid: "notfound-link-contact" },
];

export default function NotFound() {
  return (
    <MarketingShell active="/404">
      <motion.section
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: EASE }}
        className="min-h-[52vh] max-w-[52rem]"
        data-testid="notfound-page"
      >
        <p className="text-[10px] uppercase tracking-[0.32em] mb-4" style={{ color: "#F2D589" }}>
          404 &middot; wrong note
        </p>
        <h1
          className="leading-[0.95]"
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontWeight: 500,
            fontSize: "clamp(40px, 5vw, 72px)",
            textWrap: "balance",
          }}
          data-testid="notfound-heading"
        >
          That page is <em style={{ color: "#F2D589" }}>improvising</em> somewhere else.
        </h1>
        <p
          className="mt-7 text-base sm:text-lg leading-relaxed max-w-[40rem]"
          style={{ color: "rgba(245,239,227,0.8)" }}
          data-testid="notfound-copy"
        >
          Dan plays a lot of notes that aren&apos;t written down. This URL is one
          of them &mdash; it isn&apos;t on the page anywhere. Nothing is broken,
          you&apos;re just a half-step off.
        </p>
        <p className="mt-4 text-sm" style={{ color: "rgba(245,239,227,0.55)" }}>
          If you followed a link from the old Alephonics site, the method and the
          app now live at jewishmusiclab.com &mdash; the podcast stayed here.
        </p>

        <div className="mt-10 flex flex-wrap gap-3" data-testid="notfound-links">
          {LINKS.map((l, i) => (
            <Link
              key={l.to}
              to={l.to}
              className="inline-flex items-center justify-center rounded-full px-6 h-12 text-xs uppercase tracking-[0.22em] transition-colors"
              style={
                i === 0
                  ? { color: "#080419", backgroundColor: "#F2D589" }
                  : { color: "#F5EFE3", border: "1px solid rgba(255,255,255,0.25)" }
              }
              data-testid={l.testid}
            >
              {l.label}
            </Link>
          ))}
        </div>
      </motion.section>
    </MarketingShell>
  );
}
